import { memo } from "react"
import { BenefitsPlan } from "@oysterhr/schema"
import { BenefitsPlanRow } from "./BenefitsPlanRow"
import { PriceHeader } from "./PriceHeader"
import { EmptyState, Table } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"

const COLUMNS = [
  { key: "planName", title: "Plan Name" },
  { key: "category", title: "Category" },
  { key: "currencies", title: "Currencies" },
  { key: "countries", title: "Countries" },
  { key: "price", title: <PriceHeader /> },
  { key: "coveredTypes", title: "Covered Types" },
]
export interface BenefitPlansTableProps {
  benefitPlans: BenefitsPlan[]
  loading?: boolean
  onPriceClick: (plan: BenefitsPlan) => void
}

export const BenefitPlansTable = memo(
  ({ benefitPlans, loading, onPriceClick }: BenefitPlansTableProps) => {
    const { t } = useTranslation("benefits/BenefitsPage")
    const hasBenefitPlans = Boolean(benefitPlans.length)

    return (
      <Table
        isLoading={loading}
        afterTable={
          !hasBenefitPlans && (
            <EmptyState>
              <EmptyState.Content>{t("noBenefitPlansFound")}</EmptyState.Content>
            </EmptyState>
          )
        }
      >
        <Table.Head>
          <Table.Row>
            {COLUMNS.map(column => (
              <Table.Header key={column.key} scope="col">
                {column.title}
              </Table.Header>
            ))}
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {benefitPlans.map(benefitPlan => (
            <BenefitsPlanRow
              key={benefitPlan.id}
              benefitPlan={benefitPlan}
              onPriceClick={onPriceClick}
            />
          ))}
        </Table.Body>
      </Table>
    )
  },
)
